import { Link } from "react-router-dom";
import { Phone, MapPin, Clock } from "lucide-react";
import { WhatsAppIcon } from "@/components/WhatsAppIcon";
import { COMPANY, waLink } from "@/data/company";
import { SERVICES } from "@/data/services";
import { BAIRROS } from "@/data/bairros";
import { serviceUrl, bairroUrl } from "@/lib/routes";

export const Footer = () => (
  <footer className="bg-brand-dark text-gray-300" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-4 md:px-8 py-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
      <div>
        <div className="flex items-center gap-2 mb-4">
          <div className="w-10 h-10 rounded-full bg-brand-red flex items-center justify-center text-white font-heading font-black">DG</div>
          <div className="leading-tight">
            <span className="block font-heading font-black text-white text-sm uppercase">Desentupidora</span>
            <span className="block font-heading font-bold text-brand-red text-xs uppercase">em Guarulhos</span>
          </div>
        </div>
        <p className="text-sm leading-relaxed mb-4">
          Desentupidora 24 horas em Guarulhos. Desentupimento de esgoto, pia, vaso, ralo, limpeza de fossa, hidrojateamento e caixa de gordura em todos os bairros.
        </p>
        <ul className="space-y-2 text-sm">
          <li className="flex items-center gap-2"><Phone size={15} className="text-brand-red shrink-0" /><a href={`tel:${COMPANY.telefoneRaw}`} className="hover:text-white" data-testid="footer-phone-link">{COMPANY.telefone}</a></li>
          <li className="flex items-center gap-2"><MapPin size={15} className="text-brand-red shrink-0" />{COMPANY.endereco} — Guarulhos, SP</li>
          <li className="flex items-center gap-2"><Clock size={15} className="text-brand-red shrink-0" />24 horas, todos os dias</li>
        </ul>
        <p className="text-xs text-gray-500 mt-3">CNPJ: {COMPANY.cnpj}</p>
      </div>

      <div>
        <h3 className="font-heading font-bold text-white uppercase text-sm tracking-wider mb-4">Serviços</h3>
        <ul className="space-y-2 text-sm">
          {SERVICES.map((s) => (
            <li key={s.slug}><Link to={serviceUrl(s)} className="hover:text-brand-red transition-colors" data-testid={`footer-servico-${s.slug}`}>{s.nome} em Guarulhos</Link></li>
          ))}
        </ul>
      </div>

      <div>
        <h3 className="font-heading font-bold text-white uppercase text-sm tracking-wider mb-4">Bairros Atendidos</h3>
        <ul className="space-y-2 text-sm">
          {BAIRROS.map((b) => (
            <li key={b.slug}><Link to={bairroUrl(b)} className="hover:text-brand-red transition-colors" data-testid={`footer-bairro-${b.slug}`}>Desentupidora {b.prep} {b.nome}</Link></li>
          ))}
        </ul>
      </div>

      <div>
        <h3 className="font-heading font-bold text-white uppercase text-sm tracking-wider mb-4">Institucional</h3>
        <ul className="space-y-2 text-sm">
          <li><Link to="/sobre" className="hover:text-brand-red transition-colors" data-testid="footer-sobre">Sobre a Empresa</Link></li>
          <li><Link to="/bairros-atendidos" className="hover:text-brand-red transition-colors" data-testid="footer-bairros-page">Todos os Bairros</Link></li>
          <li><Link to="/blog" className="hover:text-brand-red transition-colors" data-testid="footer-blog">Blog e Dicas</Link></li>
          <li><Link to="/contato" className="hover:text-brand-red transition-colors" data-testid="footer-contato">Contato</Link></li>
        </ul>
        <a href={waLink()} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 mt-6 bg-brand-green hover:bg-brand-greenHover text-white font-heading font-bold px-5 py-3 rounded-full text-sm transition-colors" data-testid="footer-whatsapp-btn">
          <WhatsAppIcon /> Chamar no WhatsApp
        </a>
      </div>
    </div>
    <div className="border-t border-white/10 py-5 px-4 text-center text-xs text-gray-500">
      © {new Date().getFullYear()} {COMPANY.razaoSocial} — CNPJ {COMPANY.cnpj}. Todos os direitos reservados. Desentupidora 24h em Guarulhos e Região Metropolitana.
    </div>
  </footer>
);
